/**
 * Switcher (bloc accordion_image v1) : onglets desktop (.tabs a) et sélecteur mobile
 * (.tabs-select select) qui affichent un seul .body--wrapper à la fois.
 *  - le fond d'onglet .tab-bg suit l'onglet actif (transform + min-width, transition CSS
 *    dans accordion-image/_header.scss) ;
 *  - le contenu actif apparaît par animation CSS (accordion-image/_body.scss) ;
 *  - la hauteur minimale du .body suit le contenu actif (les contenus sont superposés en desktop).
 * Remplace le composant Vue Switcher (gsap → CSS, décision D1).
 */
UNYC.register('switcher', () => {
    UNYC.init('[data-switcher]', 'switcher', (root) => {
        const header = root.querySelector('.header');
        const body = root.querySelector('.body');
        const contents = body ? UNYC.qsa('.body--wrapper', body) : [];
        const select = header ? header.querySelector('.tabs-select select') : null;
        const tabs = header ? UNYC.qsa('.tabs a', header) : [];
        const tabBg = header ? header.querySelector('.tabs .tab-bg') : null;
        let active = -1;

        if (!body || !contents.length) return;

        const fitBody = () => {
            const content = contents[active];
            if (content) body.style.minHeight = `${content.offsetHeight}px`;
        };

        const moveTabBg = () => {
            const tab = tabs[active];
            if (!tabBg || !tab) return;
            tabBg.style.transform = `translateX(${tab.offsetLeft}px)`;
            tabBg.style.minWidth = `${tab.clientWidth}px`;
        };

        const tablist = header ? header.querySelector('.tabs') : null;

        if (tablist) tablist.setAttribute('role', 'tablist');
        tabs.forEach((tab) => tab.setAttribute('role', 'tab'));

        const set = (index) => {
            if (index === active || !contents[index]) return;

            active = index;
            tabs.forEach((tab, i) => {
                tab.classList.toggle('active', i === index);
                tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
            });
            contents.forEach((content, i) => content.classList.toggle('active', i === index));
            if (select && select.selectedIndex !== index) select.selectedIndex = index;
            moveTabBg();
            fitBody();
        };

        if (select) {
            select.addEventListener('change', () => set(select.selectedIndex));
        }

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', (event) => {
                event.preventDefault();
                set(index);
            });
        });

        window.addEventListener('resize', UNYC.throttleFrame(() => {
            moveTabBg();
            fitBody();
        }));

        set(0);
    });
});
